export default __webpack_public_path__ + "static/media/ellipse.28e9ca91.svg";